import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { X } from '@phosphor-icons/react';
import { PhoneFrame } from '../PhoneFrame';
import { SnakExperience } from '../experience/SnakExperience';
import type { Format } from '../../types/snak';
interface PlayOverlayProps {
  format: Format;
  showProgress: boolean;
  autoplayInterlude: boolean;
  onClose: () => void;
}

/** The Snak exactly as an end user meets it — no presentation shell. */
export function PlayOverlay({
  format,
  showProgress,
  autoplayInterlude,
  onClose
}: PlayOverlayProps) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);
  const experience = <SnakExperience showProgress={showProgress} autoplayInterlude={autoplayInterlude} data-id="element-178" data-mp="2xl3fvfue15x4" />;
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.35,
    ease: [0.22, 1, 0.36, 1]
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-[#071A16]" role="dialog" aria-modal="true" aria-label="The Meet the Filtek’s Snak" data-id="element-179" data-mp="2sma2roj0jgxh">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98,
      y: 14
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      delay: 0.05,
      ease: [0.22, 1, 0.36, 1]
    }} className={format === 'mobile' ? 'flex h-full items-center justify-center py-6' : 'no-scrollbar h-full w-full max-w-[440px] overflow-y-auto overscroll-contain'} data-id="element-180" data-mp="2emr73v7e1y22">
        {format === 'mobile' ? <PhoneFrame label="The Meet the Filtek’s Snak" sizeClassName="h-[clamp(500px,calc(100vh-56px),900px)] w-auto aspect-[344/688]" data-id="element-181" data-mp="3v0r1yrrdmxig">
            {experience}
          </PhoneFrame> : experience}
      </motion.div>

      <button type="button" onClick={onClose} aria-label="Close the prototype" className="fixed right-5 top-5 z-10 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white/70 backdrop-blur-sm transition-colors hover:bg-white/20 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-182" data-mp="31nrejezigqes">
        <X size={17} weight="bold" aria-hidden="true" data-id="element-183" data-mp="2dw2jhqvb1nu5" />
      </button>
    </motion.div>;
}